<template>
  <div class="page flex componentPage">
      <el-form :inline="true" :model="form" class='flexForm'>
            <el-col :span='5'>
                <el-form-item>
                    <el-input placeholder="手机号、真实姓名、身份证号" v-model="form.keyWord"></el-input>
                </el-form-item>
            </el-col>
            <el-form-item label=" ">
                <el-select v-model="form.cardStatus" clearable placeholder="选择绑卡状态">
                    <el-option v-for="item in cardStatus" :key="item.label" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" ">
                <el-date-picker placeholder="请选择注册时间" v-model="form.date" type='date' format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="buttonTeam floatNone">
                <el-button type="primary" @click="getUser" icon='el-icon-search'></el-button>
            </el-form-item>
        </el-form>
        <!-- <el-col :span='4'><el-button type="primary" @click="add">添加</el-button></el-col> -->
        <el-table :data='dataList' border height="100%" v-loading='pageLoading'>
            <el-table-column type='index'  label='序号' width="80"></el-table-column>
            <el-table-column prop="mobile" label="手机号" width='150'/>
            <el-table-column prop="true_name" label="真实姓名" width='130'/>
                <!-- <el-table-column prop="creator" label="创建人"/> -->
                <el-table-column prop="sex" label="性别" width='80'>
                    <template slot-scope='{row}'>
                        {{row.sex==1?'男':'女'}}
                    </template>
                </el-table-column>
                <el-table-column prop="identify_id" label="身份证号" width='230'/>
                <el-table-column prop="mailAdd" label="预审状态" width='80'>
                    <template slot-scope='{row}'>
                        <span :class='typeClass(row.fraud_type)'>{{row.fraud_type | fraudType}}</span> 
                    </template>
                </el-table-column>
                <el-table-column prop="mailAdd" label="绑卡状态" width='80'>
                    <template slot-scope='{row,$index}'>
                        <div v-if='row.remark'>
                            <el-popover
                            :ref="'pop'+$index"
                            placement="right"
                            width="230"
                            trigger="click">
                            {{row.bankName}}
                            <p>{{row.card_number}}</p> 
                            </el-popover>
                            <el-button  v-popover='"pop"+$index' type='text' title='查看卡号'>已绑卡</el-button>
                        </div>
                        <span v-else>未绑卡</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_date" label="注册时间" width='170'>
                    <template slot-scope="{row,index}">{{$date.format(row.create_date, "YYYY-MM-DD HH:mm:ss")}}</template>
                </el-table-column>
                <el-table-column prop="household_register" label="户籍所在地" />
                <el-table-column label='操作' width="220">
                    <template slot-scope='{row}'>
                        <el-button type='warning' size='mini' @click='lookBack(row)'>回访记录</el-button>
                        <el-button type='primary' size='mini' @click="loanRecord(row)">借款记录</el-button>
                    </template>
                </el-table-column>
        </el-table>
        <div class='tablepage'>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-size='pageSize'
            @current-change='getUser'
            :page-sizes="[10,20,30,40]"
            @size-change='sizeChange'
            :current-page.sync="current"
            :total="total">
        </el-pagination>
      </div>
      <!-- 查看回访记录 -->
        <el-dialog title='回访记录' :visible.sync="visible" width="60%" height='600px'>
            <return-visit v-if='visible'/>
        </el-dialog>
        <!-- 查看借款记录 -->
        <el-dialog title='借款记录' :visible.sync="visible2" class='autoDialog' width="80%" style='height:100%;'>
            <all-order :orderId='choseRow' v-if='visible2'/>
        </el-dialog>
  </div>
</template>

<script>
import returnVisit from '@/components/returnVisit.vue'
import allOrder from '@/views/child/allOrder.vue'
import { mutation } from '@/util/observable.js'
  export default {
    data () {
      return {
          form: {},
          dataList: [{}],
          title: '新增用户',
          visible: false,
          visible2: false,
          params: {},
          cardStatus: [
              {label:'已绑卡',value:0},
              {label:'未绑卡',value:1}
          ],
          current:1,
          total:0,
          pageSize:10,
          pageLoading:false,
          choseRow:null
      }
    },
    components: {
        returnVisit,allOrder
    },
    filters:{
        fraudType(val){
            switch(val){
                case 1:
                    return '已通过';
                    break;
                case 0:
                    return '未审核';
                    break;
                case 2:
                    return '未通过'
                    break;
            }
        }
    },
   methods: {
       async getUser(){
           this.pageLoading = true
           let params = {...{current:this.current,pageSize:this.pageSize},...this.form}
           const rsp = await this.$http.getMemberNotUser(params)
           this.pageLoading = false
           if(rsp.code != 200) return
           this.dataList = rsp.data.records
           this.total = rsp.data.total
       },
       async sizeChange(val){
           this.pageSize = val
           this.getUser()
       },
       //查看回访记录
       lookBack(row){
           this.visible = true
           mutation.editer(row)
        //    this.$router.push({name:'returnVisit'})
       },
       close(){
           this.visible = false
           this.getUser()
       },
       add(){
           this.params = {}
           this.visible = true
           this.title = '新增用户'
           this.params = {}
       },
       //根据不同状态，返回不同样式
       typeClass(val){
           switch(val){
                case 1:
                    return 'green';
                    break;
                case 0:
                    return 'gray';
                    break;
                case 2:
                    return 'red'
                    break;
            }
       },
       //查看借款记录
       loanRecord(row){
           this.choseRow = row.id_number
           this.visible2 = true
       }
   },
   created(){
       this.getUser()
   }
    }
</script>

<style scoped lang='scss'>
.page{
    flex-direction: column;
    span.green{
        color: #409EFF;
    }
    span.gray{
        color: #FFB800;
    }
    span.red{
        color: red;
    }
}
 
</style>
